import { render, staticRenderFns } from "./OrganizationRoleCategoryComponent.vue?vue&type=template&id=1f429a7c"
import script from "./OrganizationRoleCategoryComponent.vue?vue&type=script&lang=js"
export * from "./OrganizationRoleCategoryComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports